import styled from 'styled-components';

import { media } from '../../../../../../helpers/breakpoints';
import { spacing } from '../../../../../../helpers/genericStyles';

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.M16};
  background-color: ${({ theme }) => theme.colors.WHITE};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  ${spacing}

  ${media.medium} {
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;

export { Container };
